export const WAIT_TOLERANCE_MINUTES = 16;
export const FULL_SCORE_WAIT_EXCESS_MINUTES = 5;
export const ZERO_SCORE_WAIT_EXCESS_MINUTES = 25;
export const NO_WAIT_MARKS_LABEL = "—";
